// Shared file-name display helper.
//
// Boomerang prepends an internal file id (a UUID or short hex pair, e.g. "44bdc0c1-f9d6_")
// to every stored file so keys stay unique. That prefix is plumbing — never show it to the
// user. This strips one or more such prefixes and returns the original file name. Falls back
// to the raw name if the value were somehow all-prefix. Single source of truth so every view
// (File Upload list, Manage Projects, etc.) shows the exact same friendly name.
export const UUID_PREFIX_RE = /^(?:[0-9a-f]{8}-[0-9a-f]{4}(?:-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?_)+/i;

export const friendlyFileName = (name) => (name ? (name.replace(UUID_PREFIX_RE, "") || name) : name);
